import Vue from 'vue'
import VueSvgGauge from 'vue-svg-gauge'
Vue.use(VueSvgGauge, { global: true })
